import { Component, OnDestroy, OnInit } from '@angular/core'
import { UnsubscribeOnDestroyAdapter } from '../../../shared/adapter/unsubscribe-on-destroy-adapter'
import { LoaderService } from '../../services/loader.service'

@Component({
    selector: 'ppw-loader',
    templateUrl: 'loader.component.html',
    styleUrls: ['loader.component.scss']
})
export class LoaderComponent extends UnsubscribeOnDestroyAdapter implements OnInit, OnDestroy {
    isLoading = false

    constructor(private readonly loaderService: LoaderService) {
        super()
    }

    ngOnInit(): void {
        this.subscriptions.add(
            this.loaderService.loaderState.subscribe((isShow: boolean) => {
                this.isLoading = isShow
            })
        )
    }
}
